import { createContext } from 'react';

import { useModalProviderInit } from './hooks';

type ModalContextProps = ReturnType<typeof useModalProviderInit>;

export const ModalContext = createContext<ModalContextProps | undefined>(undefined);
ModalContext.displayName = 'ModalContext';
